<script>
	import BookingModalTab from "./BookingModalTab.svelte";
	export let issues;
</script>

<BookingModalTab tab={"drive"} {$$props} {issues} />
